// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
let module = angular.module('app.filters', []);

// The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.
require('./bytes');
require('./date-duration');
require('./config-label');
require('./day-suffix');
require('./get-by-id');
require('./mac-address');
require('./metric-suffix');
require('./number-with-unit');
require('./relative-time');
require('./remaining-time');
require('./scoreboard-team-name');
require('./seconds-formatted');
require('./simulcast-destination');
require('./simulcast-status');
require('./stream-source-name');
require('./storage-duration');
require('./trusted-url');
require('./unslugify');
require('./usage-type');

module.filter('escape', () => window.encodeURIComponent);

export default module;



// WEBPACK FOOTER //
// ./app/filters/_index.js